enum svgType {
  Line = "line",
  Polyline = "polyline",
}

interface Point2d {
  x: number;
  y: number;
}

interface SvgLine {
  points: Point2d[];
  id?: string | null;
  colour?: string | null;
  className?: string | null;
}

interface ISvgContainer {
  elId: string;
  className: string;
  svgLines: SvgLine[];
}

class SvgContainer {
  el: HTMLElement;
  constructor(props: ISvgContainer) {
    this.el = document.getElementById(props.elId)!;
    this.el.setAttribute("class", props.className);
    this.clearLines();
    if (props.svgLines.length > 0) {
      this.addLines(props.svgLines);
    }
  }

  // eg <polyline id="points="0,0 10,20 100,200" />
  private createLine({
    points: p,
    id,
    colour,
    className,
  }: SvgLine): SVGElement {
    const type: svgType = p.length === 2 ? svgType.Line : svgType.Polyline;
    let newLine: SVGElement = document.createElementNS(
      "http://www.w3.org/2000/svg",
      `${type}`
    );
    id && newLine.setAttribute("id", id);
    colour && newLine.setAttribute("style", `stroke:${colour}`);
    className && newLine.setAttribute("class", className);
    if (type === svgType.Polyline) {
      // polyline
      const svgPoints: string = `${p[0].x},${p[0].y} ${p[1].x},${p[1].y} ${p[2].x},${p[2].y}`;
      newLine.setAttribute("points", svgPoints);
    } else {
      // line
      newLine.setAttribute("x1", `${p[0].x}`);
      newLine.setAttribute("y1", `${p[0].y}`);
      newLine.setAttribute("x2", `${p[1].x}`);
      newLine.setAttribute("y2", `${p[1].y}`);
    }
    return newLine;
  }

  clearLines() {
    this.el.innerHTML = "";
  }

  addLines(svgLineData: SvgLine[]) {
    svgLineData.forEach(
      ({ points, id = null, colour = null, className = null }) => {
        const svgLine: SVGElement = this.createLine({
          points,
          id,
          colour,
          className,
        });
        this.el.append(svgLine);
      }
    );
  }
}

export { Point2d, SvgContainer, SvgLine };
